function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#0E3132",
  fillRule: "evenodd",
  d: "M11.12 5.453l1.187 1.17-5.265 5.346c-.264.27-.264.703 0 .973.25.256.67.255.917-.001l5.793-5.885c.846-.863.846-2.249 0-3.112-.807-.823-2.234-.805-3.025.002l-6.323 6.418c-1.427 1.456-1.427 3.794 0 5.25 1.386 1.415 3.768 1.392 5.132 0l7.374-7.49 1.188 1.17-7.373 7.487c-2.012 2.053-5.466 2.086-7.511 0-2.063-2.104-2.063-5.48.001-7.585l6.323-6.419c1.436-1.465 3.937-1.497 5.405 0 1.48 1.512 1.48 3.934-.002 5.447l-5.79 5.881c-.895.925-2.393.93-3.3.003-.899-.917-.899-2.388.002-3.307l5.266-5.348z",
  clipRule: "evenodd"
});

var SvgPaperclip = function SvgPaperclip(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPaperclip, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Paperclip.f882436b.svg";
export { ForwardRef as ReactComponent };